import { array, number, object, ObjectSchema, string, ValidationError } from 'yup'
import { GrupoUnidadMedidaInputProps2 } from '../interfaces'

/**
 * Validamos los datos del formulario del Grupo de Unidad de Medida
 * @param input
 */
export const grupoUnidadMedidaActualizarValidator = async (
  input: GrupoUnidadMedidaInputProps2,
): Promise<Array<string>> => {
  const schema = object({
    nombreGrupo: string().required(
      'Debe ingresar el nombre del Grupo de Unidad de Medida',
    ),
    codigoUnidadMedidaBase: string().required(
      'Debe ingresar el código de la Unidad de Medida Base',
    ),
    definicion: array()
      .of(
        object({
          codigoUnidadMedida: string().required(
            'Debe ingresar el código del unidad medida',
          ),
          cantidadBase: string().required('Debe ingresar la cantidad base'),
        }),
      )
      .min(1, 'Debe ingresar al menos una definición'),
  })

  try {
    await schema.validate(input, { abortEarly: false })
    return []
  } catch (error) {
    if (error instanceof ValidationError) {
      const errors: Array<string> = error.inner.map((err) => err.message)
      return errors
    } else {
      throw error // Re-lanzamos el error si no es una ValidationError
    }
  }
}

export const GrupoUnidadMedidaActualizarValidationSchema: ObjectSchema<any> = object({
  nombreGrupo: string().required('Debe ingresar el nombre del Grupo de Unidad de Medida'),
  codigoUnidadMedidaBase: string().required(
    'Debe ingresar el código de la Unidad de Medida Base',
  ),
  definicion: array()
    .of(
      object({
        codigoUnidadMedida: string().required(
          'Debe ingresar el código de la unidad de medida',
        ),
        cantidadBase: number().min(1).required('Debe ingresar la cantidad base'),
      }),
    )
    .required('Debe proporcionar la definición de unidades de medida'),
})
